import React, { FC } from "react";
import { Button, InputField } from "../../forms";
import { ModalPropsDTO } from "../../../typings/generic";
import { useStateGetter } from "../../../hooks/statehooks/UseStateGettersHook";
import { useForm } from "react-hook-form";
import { emailReg, numReg, textReg } from "../../../utils/regex";
import { ListPicker } from "../../generic/ListPicker";
import { usePickerhook } from "../../../hooks/usePickerhook";
import { onAddDept } from "../../../services/department";
import { toast } from "react-toastify";
import { useStateSetter } from "../../../hooks/statehooks/UseStateSettersHook";
import { useOrganizationHook } from "../../../hooks/useOrganizationHook";
import  Datepicker  from "../../generic/Datepicker";
import useDepartmentHook from "../../../hooks/useDepartmentHook";
import useEmployeeHook from "../../../hooks/useEmployeeHook";


export default (props: any) => {
  var { control, handleSubmit, watch } = useForm();
  const companypicker = usePickerhook();
  const empoymentdatepick = usePickerhook();
  const positionPickhook = usePickerhook();
  const departmentPickhook = usePickerhook();
  const { selectedOrgDepts } = useDepartmentHook();
  const { setLoading } = useStateSetter();
  const {AddEmployee}=useEmployeeHook()
  
  const watchedFields = watch([
    "title",
    "description",
     
  ]);
  const { SelectedOrg, config } = useStateGetter();
  const { UserOrgs } = useOrganizationHook();
  const areFieldsFilled = watchedFields.every(
    (field) =>
      field !== "" && field !== undefined && departmentPickhook.pickedRole
  );
  const onSubmit = async (data: any) => {
    console.log(data);

    var postdata = {
      deptID:departmentPickhook.pickedRole.code,
    organizationID: SelectedOrg.id,
     positionTitle:data.title,
    description: data.description
  }
  

    
    setLoading(true);

       await props.AddPosition(postdata);
      
      props.show(false);
    
    setLoading(false);
    props.refresh()
  };
  return (
    <>
      <div className="ModalContainer shadow ">
        <div className=" flex flex-col    rounded-[8px] bg-white w-[40vw] p-4 ">
          <p className="font-semibold self-start text-sm ">Add Position</p>
          <div className="   	 ">
            <InputField
              name="title"
              title="Position Title"
              placeholder={"title"}
              control={control}
              rules={{
                required: "title is required",
                pattern: {
                  value: textReg,
                  message: "Invalid title",
                },
              }}
            />
             
 

            
           

            <ListPicker
              fullwidth
              hook={departmentPickhook}
              title="Department"
              list={selectedOrgDepts.map((i) => {
                return { name: i.deptName, code: i.id };
              })}
            />
                <InputField
              name="description"
              title="Description"
              placeholder={"description"}
              control={control}
              isTextArea
              rules={{
                required: "description is required",
                pattern: {
                  value: textReg,
                  message: "Invalid description",
                },
              }}
            />
          </div>

          <div className=" flex justify-center items-center w-full gap-6">
            <Button
              outlined
              text="Cancel"
              onBtnClick={() => {
                props.show(false);
              }}
            />

            <Button
              disabled={!areFieldsFilled}
              text="Add Position"
              onBtnClick={handleSubmit(onSubmit)}
            />
          </div>
        </div>
      </div>
    </>
  );
};

 